export const UPGRADE_CARD_WIDTH = 136;
export const UPGRADE_CARD_HEIGHT = 420;
export const UPGRADE_CARD_CENTER_Y = 430;
export const UPGRADE_CARD_GAP = 8;

export function getUpgradeCardCenterX(
  index: number,
  choiceCount: number,
  viewWidth: number,
): number {
  const totalWidth = choiceCount * UPGRADE_CARD_WIDTH + (choiceCount - 1) * UPGRADE_CARD_GAP;
  return (viewWidth - totalWidth) / 2 + UPGRADE_CARD_WIDTH / 2 + index * (UPGRADE_CARD_WIDTH + UPGRADE_CARD_GAP);
}

export function getUpgradeChoiceIndexAt(
  x: number,
  y: number,
  choiceCount: number,
  viewWidth: number,
): number | null {
  if (Math.abs(y - UPGRADE_CARD_CENTER_Y) > UPGRADE_CARD_HEIGHT / 2) return null;

  for (let index = 0; index < choiceCount; index += 1) {
    const centerX = getUpgradeCardCenterX(index, choiceCount, viewWidth);
    if (Math.abs(x - centerX) <= UPGRADE_CARD_WIDTH / 2) return index;
  }

  return null;
}
